import { AmenityViewModel, MaxOccupancyViewModel, OffersListingTypes, RoomViewModel, ViewModel } from 'src/common/models';

import { adaptRatePlans } from './property-rate-plans-adapter';
import { mapImages } from './property-info-adapter';

export const adaptRoom = (room, __typename: string): RoomViewModel | null => {
  if (!room) {
    return null;
  }

  const spaceDetails = room.spaceDetails;
  const photos = getPhotos(room) && room.unitGallery.images.map(mapImages);
  const view = getView(room) && adaptViewModel(room.detailsDialog.content.details.header.subText);

  return {
    __typename: __typename as OffersListingTypes,
    beddingOptions: room.bedOptions,
    description: room.description,
    expandRatePlansLabel: room.ratePlansExpando?.expandButton.text,
    maxOccupancy: adaptMaxOccupancy(room.maxOccupancy),
    name: room.header?.text,
    photos,
    ratePlans: adaptRatePlans(room.ratePlans),
    roomAmenities: adaptAmenities(room.features),
    roomAmenitiesSection: room.roomAmenities,
    roomPhotosA11yHeader: room.unitGallery?.label,
    roomSize: room.size,
    roomSummary: room.header?.subText,
    roomTypeCode: room.id,
    shouldTrack3piDialog: adapt3piTracking(room.detailsDialog),
    spacesViewModel: spaceDetails,
    udpUrl: room.bookingUrl,
    view,
    unavailableRatePlans: adaptRatePlans(room.unavailableRatePlans),
  };
};

export const getMaxOccupancy = room => room.maxOccupancy;

export const getPhotos = room => room.unitGallery?.images;

export const getRoomAmenities = room => room.features;

export const getShouldTrack3piDialog = room => room.detailsDialog?.trigger.dialogTrigger.clientSideAnalytics?.referrerId;

export const getView = room => room.detailsDialog?.content.details?.header?.subText;

export const adaptMaxOccupancy = (maxOccupancy): MaxOccupancyViewModel =>
  maxOccupancy && {
    people: maxOccupancy.people,
    adults: maxOccupancy.adults,
    children: maxOccupancy.children,
    description: maxOccupancy.description,
  };

export const adapt3piTracking = (detailsDialog): boolean => {
  if (!detailsDialog) {
    return false;
  }
  const referrerId = detailsDialog.trigger.dialogTrigger?.clientSideAnalytics.referrerId || '';

  return referrerId.includes('3PI');
};

export const adaptAmenities = (roomFeatures): AmenityViewModel[] => (roomFeatures ? roomFeatures.map(adaptAmenity) : []);

export const adaptAmenity = (roomFeature): AmenityViewModel => ({
  description: roomFeature.text,
  icon: roomFeature.icon && roomFeature.icon.id,
});

export const adaptViewModel = (description): ViewModel => ({ description });
